<template>
    <div id="rightDiv1" class="panel panel-primary" style="margin-bottom: 15px;">
        <div class="panel-heading">
            <h3 class="panel-title">{{ $t("message.accountInfo") }}</h3>
        </div>
        <div class="panel-body noform">
            <div class="row">
                <div class="col-md-12">
                    <label class="controlLabel">{{ $t("message.accountNumber") }}</label><br />
                    <label v-text="accountInformation.AccountNumber" />
                </div>
            </div>
            <div class="row top15">
                <div class="col-md-12">
                    <label class="controlLabel">{{ $t("message.serviceLocationAddress") }}</label><br />
                    <label v-text="accountInformation.ServiceLocationFullAddress" />
                </div>
            </div>
            <div class="row top15" v-if="accountInformation.ShowEBill">
                <div class="col-md-12">
                    <label class="controlLabel">{{ $t("message.billOptions") }}</label><br />
                    <label v-text="accountInformation.EBillStatus" />&nbsp;<a href="#" @click="confirmEBillChange()">{{ $t("message.change") }}</a>
                </div>
            </div>
            <div class="row top15" v-if="accountInformation.ShowAutopay">
                <div class="col-md-12">
                    <label class="controlLabel">{{ $t("message.autopay") }}</label><br />
                    <label v-text="accountInformation.AutopayStatus" for="lnkAutopay" />&nbsp;<a id="lnkAutopay" href="#" @click="autopayEnroll()">{{ $t("message.change") }}</a>
                </div>
            </div>            
            
            <!-- Upcoming Payment Arrangement -->
            <div class="row top15" v-if="accountInformation.ShowPaymentArrangement">
                <div class="col-md-12">
                    <label class="controlLabel">{{ $t("message.upcomingPaymentArrangement") }}</label> <br/>
                    <!-- <a href="#" id="lnkExpandUpcomingArrangement" data-action="open" onclick="displayPaymentArrangementDetails(this); return false;"><i class="fa fa-plus"></i></a>&nbsp;
                    <asp:Literal runat="server" ID="ltlPaymentArrangement"></asp:Literal> -->
                </div>
                <div class="col-md-5">
                    <div id="divPaymentArrangementDetails" class="pa-details-main" style="display: none;">
                        <!-- <asp:Literal runat="server" ID="ltlPaymentArrangementDetails"></asp:Literal> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios"

export default {
    name: 'AccountInformation',
    data() {
        return {
            accountInformation: '',
            accountInformationLoaded: false
        }
    },
    mounted() {
        axios({
            method: "POST",
            url: this.$httpAxiosBaseUrl() + "Home/GetAccountInformation"
        }).then(result => {
            var response = result.data;
            if (response !== '') {
                this.accountInformation = response;
                this.accountInformationLoaded = true;
            }
        }, error => {
            console.log(error);
        });     
    },
    methods: {
        confirmAndFinalizeEBillChange() {
            // TODO: implement for 3.0
        },
        autopayEnroll() {
            this.$router.push({ name: 'Autopay' });
        }
    }
}
</script>